import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "audienceBox",
        "form",
        "formRow",
        "typeSelect",
        "typeLabel",
        "weekdaySelect",
        "keywordInput"
    ]

    connect() {
        this.selectedAudience = null

        if (this.hasTypeSelectTarget) {
            try {
                const rawData = this.typeSelectTarget.dataset.typeAgeMapping
                this.typeAgeMapping = JSON.parse(rawData || '[]')
            } catch (e) {

                this.typeAgeMapping = []
            }
        }

        this.audienceBoxTargets.forEach(box => {
            box.addEventListener("click", () => {
                this.selectAudience(box)
            })
        })

        if (this.hasFormTarget) {
            this.formTarget.addEventListener("submit", e => {
                this.submit(e)
            })
        }

        this.audienceBoxTargets[0].classList.add("active")
        this.selectedAudience = {
            ageRange: this.audienceBoxTargets[0].dataset.ageRange,
            audience: this.audienceBoxTargets[0].dataset.audience
        }

        this.updateTypeLabel()
        this.filterTypeOptions()
    }

    selectAudience(box) {
        this.audienceBoxTargets.forEach(b => b.classList.remove("active"))
        box.classList.add("active")

        this.selectedAudience = {
            ageRange: box.dataset.ageRange,
            audience: box.dataset.audience
        }

        this.updateTypeLabel()
        this.filterTypeOptions()
    }

    filterTypeOptions() {
        if (!this.hasTypeSelectTarget || !this.selectedAudience) return

        const currentValue = this.typeSelectTarget.value
        const selectedAgeRange = this.selectedAudience.ageRange

        const placeholderOption = this.typeSelectTarget.options[0]
        this.typeSelectTarget.innerHTML = ''
        this.typeSelectTarget.appendChild(placeholderOption)

        const [selectedMin, selectedMax] = selectedAgeRange.split('-').map(n => parseInt(n))

        if (isNaN(selectedMin) || isNaN(selectedMax)) return

        this.typeAgeMapping.forEach(type => {
            const ageRangesArray = Array.isArray(type.age_ranges)
                ? type.age_ranges
                : Object.values(type.age_ranges)

            const hasMatch = ageRangesArray.some(ageRange => {
                const rangeStr = String(ageRange).trim()
                if (!rangeStr.includes('-')) return false

                const parts = rangeStr.split('-')
                if (parts.length !== 2) return false

                const min = parseInt(parts[0])
                const max = parseInt(parts[1])

                if (isNaN(min) || isNaN(max)) return false

                return min <= selectedMax && max >= selectedMin
            })

            if (hasMatch) {
                const option = document.createElement('option')
                option.value = type.slug
                option.textContent = type.name
                this.typeSelectTarget.appendChild(option)
            }
        })

        if (currentValue && this.typeSelectTarget.querySelector(`option[value="${currentValue}"]`)) {
            this.typeSelectTarget.value = currentValue
        } else {
            this.typeSelectTarget.value = ''
        }
    }

    updateTypeLabel() {
        if (!this.hasTypeLabelTarget || !this.hasFormRowTarget) return

        const formRow = this.formRowTarget
        let labelText = formRow.dataset.labelDefault

        switch (this.selectedAudience.audience) {
            case "children":
                labelText = formRow.dataset.labelChildren
                break;
            case "teen":
                labelText = formRow.dataset.labelTeen
                break;
            case "adult":
                labelText = formRow.dataset.labelAdult
                break;
        }

        this.typeLabelTarget.textContent = labelText
    }

    submit(event) {
        event.preventDefault()
        const params = new URLSearchParams()

        if (this.hasTypeSelectTarget && this.typeSelectTarget.value) {
            params.append("page_types[]", this.typeSelectTarget.value)
        }

        if (this.hasWeekdaySelectTarget && this.weekdaySelectTarget.value && this.weekdaySelectTarget.value !== "-1") {
            params.append("page_occurrences[]", this.weekdaySelectTarget.value)
        }

        if (this.hasKeywordInputTarget && this.keywordInputTarget.value.trim() !== "") {
            params.append("keyword", this.keywordInputTarget.value.trim())
        }

        if (this.selectedAudience) {
            switch (this.selectedAudience.audience) {
                case "children":
                    params.append("age", "0-11")
                    break;
                case "teen":
                    params.append("age", "12-17")
                    break;
            }
        }

        let link = "";

        switch (this.selectedAudience.audience) {
            case "children":
                link = "bureliai"
                break;
            case "teen":
                link = "bureliai"
                break;
            case "adult":
                link = "paslaugos/uzsiemimai-suaugusiems-ir-seimai"
                break;
            case "teacher":
                link = "paslaugos/tikri-mokymai"
                break
        }

        window.location.href = `/${link}/?${params.toString()}`
    }
}
